import styled from "styled-components";

export const MasterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-inline: 25px;
  width: 100%;
  max-width: 1400px;
  gap: 12px;
  background-color: ${({ theme }) => theme?.colors?.white || '#FFFFFF'};
`;

export const LeftIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  cursor: pointer;
  color: ${({ theme }) => theme?.colors?.darkCharcoal || '#333333'};
  
  &:hover {
    color: ${({ theme }) => theme?.colors?.celticBlue || '#2173FF'};
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  flex: 1;
  max-width: 400px;
  min-width: 300px;
`; 